import { ArrowLeftSvgIcon } from './svg';
import { makeIcon } from './make-icon';

export const ArrowLeftIcon = makeIcon(ArrowLeftSvgIcon, 'ArrowLeftSvgIcon')`
  /* height: 1em;
  width: 1em; */
  position: relative;
  top: 0.1em;
  g {
    stroke: currentColor;
  }
`;
